import { styled } from '@linaria/react';
import { UnstyledButton } from '@mantine/core';
import { icons } from '../../assets/icons/icons';
import { useTranslation } from 'react-i18next';
import { useGlobalStore } from '../../store/global-store/global-store';
import { Tooltip } from '../../ui-library/tooltip/tooltip';
import { useFlora } from './flora.context';

type FloraButtonProps = {
  externalData?: any[];
  prompt?: string;
  size?: number;
  tooltipText?: string;
  disabled?: boolean;
};

export const FloraButton = ({ externalData, size = 25, tooltipText, prompt, disabled }: FloraButtonProps) => {
  const i18n = useTranslation();
  const { isFloraVisible, toggleFlora, askQuestion } = useFlora();
  const { useAI } = useGlobalStore();
  const inputPrompt = prompt ?? i18n.t('flora.process_analysis.measure_comparison_chart_prompt');
  const handleClick = () => {
    if (externalData) {
      let dataPrompt = inputPrompt;
      for (const data of externalData) {
        dataPrompt += JSON.stringify(data);
      }
      askQuestion(dataPrompt);
    } else {
      toggleFlora();
    }
  };

  if (isFloraVisible) {
    return null;
  }

  if (!useAI) {
    return null;
  }

  return tooltipText ? (
    <Tooltip label={tooltipText} variant="black" offset={8}>
      <StyledButton onClick={handleClick} disabled={disabled} data-bf="header-btn-flora">
        <img src={icons.iconFlora} alt="Flora AI" style={{ width: size, height: size }} />
      </StyledButton>
    </Tooltip>
  ) : (
    <StyledButton onClick={handleClick} disabled={disabled} data-bf="header-btn-flora">
      <img src={icons.iconFlora} alt="Flora AI" style={{ width: size, height: size }} />
    </StyledButton>
  );
};

const StyledButton = styled(UnstyledButton)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 4px;
  transition: background 0.2s ease;

  &:hover {
    background: rgba(0, 0, 0, 0.05);
  }
`;
